<div class="settings-card-stack">
  <mat-card class="settings-container">
    <app-card-header-with-action
      title="Anrufeinstellungen"
      i18n-title
      [actionEnabled]="!!settings$()"
      (actionClicked)="onEditCallSettings()"
    ></app-card-header-with-action>

    <mat-list>
      @if (aiFollowUpTasksAvailable() && settings$(); as settings) {
        <mat-list-item>
          <mat-icon matListItemIcon>task_alt</mat-icon>
          <div matListItemTitle i18n="@@profileAiFollowUpTasks">
            KI-Folgeaufgaben
          </div>
          <div matListItemLine>
            @if (settings.aiFollowUpTasksEnabled === false) {
              <span i18n="@@profileAiFollowUpTasksOff">Aus</span>
            } @else {
              <span i18n="@@profileAiFollowUpTasksOn">An</span>
            }
          </div>
        </mat-list-item>
      }

      <mat-list-item>
        <mat-icon matListItemIcon>translate</mat-icon>
        <div matListItemTitle>
          <span i18n>Bevorzugte Sprache</span>
        </div>
        <div matListItemLine>
          <span>{{ preferredLanguageLabel$() }}</span>
        </div>
      </mat-list-item>

      <mat-list-item>
        <mat-icon matListItemIcon>timer</mat-icon>
        <div matListItemTitle>
          <span i18n>Foto Countdown</span>
        </div>
        <div matListItemLine>
          <span i18n>{photoCountdown$(), plural,
            =1 {{{ photoCountdown$() }} Sekunde}
            other {{{ photoCountdown$() }} Sekunden}
          }</span>
        </div>
      </mat-list-item>

      <mat-list-item>
        <mat-icon matListItemIcon>videocam</mat-icon>
        <div matListItemTitle>
          <span i18n>Live Recording Dauer</span>
        </div>
        <div matListItemLine>
          <span i18n>{liveImageDuration$(), plural,
            =1 {{{ liveImageDuration$() }} Sekunde}
            other {{{ liveImageDuration$() }} Sekunden}
          }</span>
        </div>
      </mat-list-item>

      <mat-list-item>
        <mat-icon matListItemIcon>sms</mat-icon>
        <div matListItemTitle>
          <span i18n>Bevorzugte Länder für Benachrichtigungen</span>
        </div>
        <div matListItemLine>
          <span>{{ getFavoriteSmsCountriesText(settings$()) }}</span>
        </div>
      </mat-list-item>
    </mat-list>
  </mat-card>

  <mat-card class="settings-container">
    <app-card-header-with-action
      title="Profileinstellungen"
      [actionEnabled]="!!settings$()"
      (actionClicked)="onEditProfileSettings()"
    ></app-card-header-with-action>

    <mat-list>
      <mat-list-item>
        <mat-icon matListItemIcon>language</mat-icon>
        <div matListItemTitle>
          <span i18n>Anzeigesprache</span>
        </div>
        <div matListItemLine>
          <span>{{ displayLanguageLabel$() }}</span>
        </div>
      </mat-list-item>
    </mat-list>
  </mat-card>
  <app-notification-settings-card />
</div>
